export default "__VITE_ASSET__D5H3fIEj__"